import React from 'react';
import { Box, Card, CardContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';

interface DataTableProps {
  children: React.ReactNode;
  minWidth?: number;
  emptyMessage?: string;
  emptyColSpan?: number;
}

export const DataTable: React.FC<DataTableProps> = ({
  children,
  minWidth = 1400,
  emptyMessage = 'データがありません',
  emptyColSpan = 1,
}) => {
  return (
    <Card
      sx={{
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '0px 3px 12px #00000026',
        borderRadius: '24px',
      }}
    >
      <CardContent
        sx={{
          px: 0,
          pt: 0,
          pb: 0,
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            height: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '3px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
            },
          },
        }}
      >
        <TableContainer
          sx={{
            overflowX: 'visible',
            minWidth,
          }}
        >
          <Table sx={{ minWidth }}>
            {children}
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export const EmptyTableRow: React.FC<{ colSpan: number; message?: string }> = ({
  colSpan,
  message = 'データがありません',
}) => (
  <TableRow>
    <TableCell colSpan={colSpan} sx={{ py: 1.5, borderBottom: 'none' }}>
      <Typography
        variant="body1"
        sx={{
          color: '#9E9E9E',
          fontSize: '14px',
        }}
      >
        {message}
      </Typography>
    </TableCell>
  </TableRow>
);

